import { Box, Link } from '@hover/blueprint';
import React from 'react';

import { CallToActionButton } from '../CallToActionButton';
import { NavigationLink } from '../NavigationLink';

interface LargerThanMobileProps {
  links: NavigationLink[];
}

const LargerThanMobile = ({ links }: LargerThanMobileProps) => (
  <Box
    alignItems="center"
    display={{ base: 'none', tablet: 'grid' }}
    gridColumnGap={800}
    gridTemplateColumns={`repeat(${links.length + 1}, auto)`}
  >
    {links.map(({ label, path }: NavigationLink) => (
      <Link href={path} key={path}>
        {label}
      </Link>
    ))}
    <CallToActionButton />
  </Box>
);

export { LargerThanMobile };
